module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10+ Flamingo Pink.0b2ea43e.png";